export default "__VITE_ASSET__3Ha8XwTr__"